import { TIP_MODES } from "Components/Shared/TipSelector/types";
import { z } from "zod";

export const standardPaymentSchema = z.object({
  publicID: z.string(),
  bankAccountPublicID: z.string().min(1),
  tipMode: z.enum(TIP_MODES),
  customTipAmount: z.number().positive().optional(),
});
export type StandardFormModel = z.infer<typeof standardPaymentSchema>;

// Collector covers Fixed (predefined amount + optional tip) and Editable (customer picks amount).
// Per-branch fields are kept optional and gated at render/submit time by the form using
// transactionDetails.payPointPredefinedAmount. No publicID — the transaction doesn't exist yet
// when this form mounts; it's created by /scan on submit.
export const collectorPaymentSchema = z.object({
  bankAccountPublicID: z.string().min(1),
  tipMode: z.enum(TIP_MODES).optional(),
  customTipAmount: z.number().positive().optional(),
  customAmount: z.number().positive().optional(),
});
export type CollectorFormModel = z.infer<typeof collectorPaymentSchema>;
